// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"1b3ae74a","667":"91c7ea71","977":"54d1b97c"}[chunkId] + ".chunk.js");